var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuotes = function SvgQuotes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    style: {
      width: 80
    },
    viewBox: "0 0 92 65"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h91.342v64.366H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#46e1c8",
    fillRule: "nonzero",
    d: "M37.885.4A38.03 38.03 0 0 0 .958 39.363v4.869a19.35 19.35 0 0 0 11.947 17.886 19.36 19.36 0 0 0 26.394-14.107A19.357 19.357 0 0 0 20.311 24.88a18 18 0 0 0-4.368.548.977.977 0 0 1-1.215-.891.98.98 0 0 1 .13-.55 26.77 26.77 0 0 1 23.027-13.795 4.895 4.895 0 0 0 0-9.792M85.72.4a38.03 38.03 0 0 0-36.928 38.963v4.869A19.35 19.35 0 0 0 60.74 62.118a19.36 19.36 0 0 0 26.394-14.107A19.357 19.357 0 0 0 68.145 24.88a18 18 0 0 0-4.368.548.977.977 0 0 1-1.215-.891.98.98 0 0 1 .13-.55A26.77 26.77 0 0 1 85.72 10.192a4.895 4.895 0 0 0 0-9.792"
  })));
};
export default SvgQuotes;